<template>
  <div class="car-archive-details">
    <div class="car-archive-details-content">
      <div class="car">
        <div class="row">
          <div v-for="(i, index) in baseInfo" :key="index">
            <span>{{ i.name }}</span>
            <span>{{ i.value }}</span>
          </div>
        </div>
      </div>
      <div class="vin">
        <div class="table">
          <el-table ref="table" :data="tableList" style="width: 100%">
            <el-table-column 
              v-for="(item, index) in tableTitleList"
              :key="index"
              :label="item.label"
              :prop="item.prop"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { modifyNetTitle } from "common/js/util";
import SmartVehicleInspection from "models/smart-vehicle-inspection/smart-vehicle-inspection";
export default {

  data() {
    return {
      baseInfo: [
        {name: '批次号：', value: ''},
        {name: '作业类型：', value: ''},
        {name: '品牌：', value: ''},
        {name: '到港时间：', value: ''}
      ],
      tableList: [],
      tableTitleList: [
        {label: '序号', prop: 'sort'},
        {label: '车架号', prop: 'vin'}
      ]
    }
  },
  created() {
    modifyNetTitle('批次管理详情')
    this.initDetails()
  },

  methods: {
    initDetails() {
      const id = Number(this.$route.query.id)
      SmartVehicleInspection.getBatchDetails(id).then(res => {
        if (res.success) {
          const { batchNo, jobType, brandName, arrivalDate, vins } = res.result
          this.baseInfo = [
            {name: '批次号：', value: batchNo},
            {name: '作业类型：', value: jobType === 1?'接收检验':'移交检验'},
            {name: '品牌：', value: brandName},
            {name: '到港时间：', value: arrivalDate}
          ]
          
          let arr = [];
          vins.map((value, index) => {
            let obj = {};
            obj.sort = index+1;
            obj.vin = value;
            arr.push(obj);
          });
          this.tableList = arr;
        }
      })
    },
  }
}
</script>

<style lang='scss' scoped>
.car-archive-details {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  .car-archive-details-content {
    height: 100%;
    padding: 24px 30px;
    background: #fff;
    border-radius: 8px;
    .car {
      width: 100%;
      border-bottom: 1px solid #eee;
      padding-bottom: 24px;
      margin-bottom: 24px;
      .row {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        row-gap: 24px;
        column-gap: 24px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
      }
    }
  }
}
</style>
